module.exports = __webpack_public_path__ + "static/lightning-table-expandable-base-65db39bc0b3badc88884d3fcc4685e5d.png";